import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosAplicacionesService,
  ProductoItem,
} from "../../../../generated/grpc/catalogos_aplicaciones_pb";

/** Variante gRPC-Web (con delta) de `ProductoGetCatalogService` (ver ese archivo). */
export class ProductoGrpcCatalogService extends BaseGrpcCatalogService<ProductoItem> {
  protected readonly storeName = "productos" as const;
  protected readonly sortFieldName = "descripcion";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<ProductoItem>> {
    const client = createClient(CatalogosAplicacionesService, grpcTransportProvider.get());

    try {
      const response = await client.listProductos({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de productos. */
export const productoGrpcCatalogService = new ProductoGrpcCatalogService();
